/**
 * Eiendomsrett Module Description
 * Master Grade modul for eiendomsrett
 */
import { MasterGradeBadge, ModuleSection, FeatureList, PrivacyNotice } from '../../shared';

export const EIENDOMSRETT_CONFIG = {
  id: 'eiendomsrett',
  title: 'Eiendomsrett',
  status: 'active',
  badge: 'Master',
  
  masterDescription: "er RettVerks mest avanserte nivå. Den kombinerer full faglig dekning innen eiendomsrett med lokal AI-drevet tekstanalyse, automatisk fristberegning og generering av strukturerte dokumentutkast. Modulen er utviklet for å gi deg et helhetlig verktøy for boligkjøp, nabotvister og leieforhold.",
  
  aboutModule: "Eiendomsrett-modulen gir deg verktøy for å håndtere mangler ved boligkjøp, nabotvister og leieforhold, basert på avhendingslova, naboloven og husleieloven.",
  
  features: [
    "Strukturert reklamasjonsportal for skjulte mangler ved boligkjøp (avhendingslova)",
    "Nabovarsel-generator iht. plan- og bygningsloven med lovpålagte krav",
    "Husleiekontrakt-generator med lovlig balanse mellom utleier og leietaker",
    "Beregner reklamasjonsfrister automatisk (absolutt frist: 5 år fra overtagelse)",
    "Verktøy for tvisthåndtering mellom naboer – trær, støy og byggetiltak"
  ],
  
  privacyText: "All analyse og behandling skjer lokalt på din enhet. Kontrakter og dokumenter lastes ikke opp, lagres ikke på servere og deles ikke med RettVerk."
};

export function EiendomsrettDescription() {
  const config = EIENDOMSRETT_CONFIG;
  
  return (
    <div className="space-y-5 max-h-[65vh] overflow-y-auto pr-2">
      <MasterGradeBadge description={config.masterDescription} />
      
      <ModuleSection icon="📋" title="Om modulen">
        <p className="text-sm text-[var(--text-muted)] leading-relaxed">
          {config.aboutModule}
        </p>
      </ModuleSection>
      
      <ModuleSection icon="⚙️" title="Funksjoner">
        <FeatureList features={config.features} />
      </ModuleSection>
      
      <PrivacyNotice text={config.privacyText} />
    </div>
  );
}

export default EiendomsrettDescription;
